import React, {useEffect} from 'react';
import {appId, baseUrl, reCaptchaSiteKey} from '../../settings';

const reCaptchaSecretKey = process.env.REACT_APP_RECAPTCHA_SECRET_KEY;

function Recaptcha() {
  useEffect(() => {
    //ReCAPTCHA onloadCallback
    const reCaptchaScript1 = document.createElement('script');

    reCaptchaScript1.textContent = `
      function verifyCallback(recaptchaToken) {
        return fetch('${baseUrl}', {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'x-mv-appid': '${appId}',
            'x-mv-timestamp': new Date().getTime(),
          },
          body: JSON.stringify({
            query: 'query ($recaptchaToken: String!, $recaptchaSecretKey: String!) { recaptcha(recaptchaToken: $recaptchaToken, recaptchaSecretKey:$recaptchaSecretKey) {success time hostname errors}}',
            variables: {
              recaptchaToken,
              recaptchaSecretKey: '${reCaptchaSecretKey}',
            },
          }),
        })
        .then(res => res.json())
        .then(res => {
          const recaptchaResponse = res?.data?.recaptcha
          window.recaptchaPassed = recaptchaResponse?.success;
          if (window.recaptchaPassed) setTimeout(()=> window.recaptchaPassed=false, 60000);
        }).catch(err => {
          console.log(err)})
      }
        
      var onloadCallback = function () {
        grecaptcha.render('recaptcha_element', {
          'sitekey': '${reCaptchaSiteKey}', 
          'callback': verifyCallback, 
        })
        document.querySelector("iframe").setAttribute("data-testid", "reCAPTCHA")
      };
    `;
    document.head.appendChild(reCaptchaScript1);

    // ReCAPTCHA Resource
    const reCaptchaScript2 = document.createElement('script');
    reCaptchaScript2.src =
      'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit'; // Replace with the URL of your script
    reCaptchaScript2.async = true;
    reCaptchaScript2.defer = true;
    document
      .getElementById('recaptcha-container')
      .appendChild(reCaptchaScript2);

    return () => {
      document.head.removeChild(reCaptchaScript1);
      const recaptchaContainer = document.getElementById('recaptcha-container');

      if (recaptchaContainer) recaptchaContainer.removeChild(reCaptchaScript2);

      delete window.recaptchaPassed;
    };
  }, []);
  return (
    <div id='recaptcha-container' className='py-4'>
      <div id='recaptcha_element' data-testid='recaptcha_element'></div>
    </div>
  );
}

/** Browswer should have access to Variable window.recaptchaPassed when mounted */
export default Recaptcha;
